"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _utilities = require("../utilities");
var _Divider = require("./Divider.styles");
const _excluded = ["className", "component", "orientation"];
/**
 * **❗️ DEPRECATED**: Use the new `Divider` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/data-display-divider):
 *
 * ```tsx
 * import { Divider } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/horizon-web-ui-kit/?path=/docs/data-display-divider)
 *
 * @deprecated
 */
const Divider = _ref => {
  let {
      className,
      component: Component = 'hr',
      orientation = 'horizontal'
    } = _ref,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    classes,
    css,
    cx,
    theme
  } = (0, _Divider.useStyles)();
  const {
    styles,
    colors
  } = theme.busbud;
  const cssVariables = css({
    [_Divider.DIVIDER_CSS_VARIABLES.color]: colors.component.divider.background,
    [_Divider.DIVIDER_CSS_VARIABLES.thickness]: styles.component.divider.thickness,
    [_Divider.DIVIDER_CSS_VARIABLES.rounding]: styles.component.divider.rounding
  });
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    "aria-orientation": orientation,
    className: cx(cssVariables, classes.root, classes[`orientation${(0, _utilities.capitalizeFirstWord)(orientation)}`], className),
    role: "separator"
  }, restProps));
};
var _default = exports.default = Divider;